import type { Settlement } from '../engine/map/settlement';
import { recordProduced } from '../engine/map/settlement';
import { getGameConfig } from '../config/gameConfig';
import { getBuildingStorage, getEffectiveOutputCap } from '../engine/settlement/utils';

export function runIronMineTick(settlement: Settlement): boolean {
    if (settlement.buildings.ironMine.qty <= 0 || settlement.jobs.miners <= 0) {
        const hadWork = settlement.production.ironMine.progress.length > 0;
        settlement.production.ironMine.progress = [];
        return hadWork;
    }
    let changed = false;
    const config = getGameConfig();
    const outputCap = getEffectiveOutputCap(settlement, config, 'ironMine', 'ironOre');
    const storage = getBuildingStorage(settlement, 'ironMine');
    while (settlement.production.ironMine.progress.length < settlement.jobs.miners) {
        settlement.production.ironMine.progress.push(0);
        changed = true;
    }
    while (settlement.production.ironMine.progress.length > settlement.jobs.miners) {
        settlement.production.ironMine.progress.pop();
        changed = true;
    }

    if (settlement.regionResources.ironDeposit <= 0) return changed;

    const ticksPerOre = config.production.ironMine.ticksPerOre;
    for (let i = 0; i < settlement.production.ironMine.progress.length; i += 1) {
        if (settlement.regionResources.ironDeposit <= 0) break;
        if (outputCap <= 0 || outputCap - storage.ironOre < 1) break;
        settlement.production.ironMine.progress[i] += 1;
        if (settlement.production.ironMine.progress[i] >= ticksPerOre) {
            settlement.production.ironMine.progress[i] -= ticksPerOre;
            settlement.regionResources.ironDeposit = Math.max(
                0,
                settlement.regionResources.ironDeposit - 1,
            );
            storage.ironOre += 1;
            recordProduced(settlement, 'ironOre', 1);
            changed = true;
        }
    }

    return changed;
}
